<app-v2-faq-card *ngFor="let q of question; let i = index" [card]="'card' + i" [title]="q.question"
    [response]="q.answer">
</app-v2-faq-card>